__turbopack_context__.v({
  "jetCatalog": "jetCatalog-module-scss-module__g5dt0a__jetCatalog",
  "jetCatalogItems": "jetCatalog-module-scss-module__g5dt0a__jetCatalogItems",
  "jetCatalogSection": "jetCatalog-module-scss-module__g5dt0a__jetCatalogSection",
  "jetCatalogSwiper": "jetCatalog-module-scss-module__g5dt0a__jetCatalogSwiper",
});
